<script>
import 'animate.css'
import { WOW } from 'wowjs'

export default {
  data() {
    return {
      list: [
        {
          title: '24/7 線上線下整合預約',
          subTitle: 'Quick and Simple',
          content: '<p>處理預訂交給i寵訂，您可以花更多的時間在提供更好的服務！<br>同時具備線上與線下的預訂功能，一方面讓客戶隨時隨地的在網站預約，減少電話漏接、訊息晚回造成丟單的狀況；另一方面，管理後台清晰的行事曆排程，讓您可輕鬆靈活地在空檔時段新增訂單，避免重複預訂！</p>',
          bg: require('@assets/images/basicplan/blob-1.svg'),
          img1: require('@assets/images/adminImgs/home_calandar.png'),
          img2: require('@assets/images/adminImgs/home_calandar.png'),
        },
        {
          title: '了解客戶與寶貝寵物們',
          subTitle: 'Happy Owners & Pets',
          content: '<ul class="list-unstyled isStyleBase"><li><h3 class="title">客戶管理</h3><p class="content">了解客戶資訊與消費，同時也能輕鬆將客戶分級標籤，管理客戶輕鬆上手！</p></li><li><h3 class="title">寵物管理</h3><p class="content">獨家寵物訂單模式，也能將每次服務紀錄，讓每隻寵物都有最佳的服務歷程！</p></li></ul>',
          bg: require('@assets/images/basicplan/blob-2.svg'),
          img1: require('@assets/images/adminImgs/interface07@1.png'),
          img2: require('@assets/images/adminImgs/interface07@1.png'),
        },
        {
          title: '服務人員管理',
          subTitle: 'Employees ',
          content: '<p>可依照每位員工的狀況，設定能提供貓咪、狗狗或其他動物的服務。<br>員工之間可保有工作績效的隱私，以及查看他們的日程安排，事前知道要照顧的寵物們，並清楚紀錄接待過的寵物。</p>',
          bg: require('@assets/images/basicplan/blob-3.svg'),
          img1: require('@assets/images/adminImgs/interface08@1.png'),
          // img2: require('@assets/images/adminImgs/basicplan_emplouees.png'),
        },
        {
          title: '彈性排班方式 人員輕鬆分配',
          subTitle: 'Scheduleing',
          content: '<p>支援單日多段式排班，可設定重複性或一次性排班，滿足多元排班需求。<br>店長以上權限均可設定排班，並自動計算每月排班時數，擺脫繁複人工作業計算。<br>亦有跨分店排班功能，不必煩惱安排員工跨店支援問題。</p>',
          bg: require('@assets/images/basicplan/blob-2.svg'),
          img1: require('@assets/images/adminImgs/home_sechedle.png'),
          // img2: require('@assets/images/adminImgs/basicplan_schedule.png'),
        },
        {
          title: '適用不同職位的權限',
          subTitle: 'User Roles',
          content: '<p>多種專業清楚的分工與管理權限。您可透過簡單的操作有效分配職位權責，掌控員工的瀏覽操作權限，讓您同時保有商業經營隱私，又可讓經營更加完善。</p>',
          bg: require('@assets/images/basicplan/blob-5.svg'),
          img1: require('@assets/images/adminImgs/interface09@1.png'),
          // img2: require('@assets/images/adminImgs/basicplan_role.png'),
        }
      ]
    }
  },
  mounted() { 
    this.$nextTick(() => {  
      let wow = new WOW({
        live:false
      })
      wow.init()
    })
  }
}
</script>

<template>
  <div :class="$style.sectionFeatures">
    <!-- <img src="@assets/images/home/section7-image.png" alt="" class="sectionSecondary__img"> -->
    <div class="container section">
      <div 
        v-for="(item, $index) in list"
        :key="$index"
        class="row sectionFeatures__list text-xl-left text-center" 
        :class="{ 'flex-row-reverse': $index % 2 === 1 }"
      >
        <div class="col-xl-5 col-12 align-self-center">
          <div v-if="$index % 2 === 1" class="wow animate__animated animate__fadeInRight">
            <BaseSectionTitle 
              :title="item.title" 
              :sub-title="item.subTitle" 
              class="isStyleDecoration mx-xl-0 isxlCenter mx-auto"
            />
            <div class="sectionFeatures__content" v-html="item.content">

            </div>
          </div>
          <div v-else class="wow animate__animated animate__fadeInLeft">
            <BaseSectionTitle 
              :title="item.title" 
              :sub-title="item.subTitle" 
              class="isStyleDecoration mx-xl-0 isxlCenter mx-auto"
            />
            <div class="sectionFeatures__content" v-html="item.content">

            </div>
          </div>
        </div>
        <div class="col-xl-7 col-12 sectionFeatures__img">
          <div
            v-if="$index % 2 === 1" 
            :class="`sectionFeatures__img--item item${$index}`"
            class="mt-xl-0 mt-5 wow animate__animated animate__fadeInLeft left"
          >
            <img
              class="img" 
              :src="item.img1" 
              alt=""
            >
          </div>
          <div
            v-else
            :class="`sectionFeatures__img--item item${$index}`"
            class="mt-xl-0 mt-5 wow animate__animated animate__fadeInRight right"
          >
            <img
              class="img" 
              :src="item.img1"
              alt=""
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.sectionFeatures {
  position: relative;
  overflow: hidden;
  @include max-xl {
    margin-top: -70px;
  }
  @include max-lg {
    margin-top: 0;
    padding-top: 70px;
  }
  &:before {
    content:'';
    position: absolute;
    background-image: url('@assets/images/basicplan/paw-1.svg');
    background-repeat: no-repeat;
    background-size: cover;
    width: 9%;
    padding-bottom: 10%;
    top: 15%;
    left: 0;
    @include max-lg {
      display: none;
    }
  }
  &:after {
    content:'';
    position: absolute;
    background-image: url('@assets/images/basicplan/paw-2.svg');
    background-repeat: no-repeat;
    background-size: cover;
    width: 9%;
    padding-bottom: 11%;
    bottom: 35%;
    right: 0;
    @include max-lg {
      display: none;
    }
  }
  :global {
    .sectionFeatures {
      &__img {
        // position: relative;
        // padding-bottom: 34%;
        // // @include max-md {
        // //   padding-bottom: 78%;
        // // }
        // .img {
        //   position: absolute;
        //   top: 0;
        //   left: 0;
        //   right: 0;
        //   bottom: 0;
        //   // background: #bed6da;
        //   background-size: cover;
        //   background-repeat: no-repeat;
        //   background-position: center;
        // }
      }
      &__content {
        color: $color-text-2;
        @include max-md {
          font-size: 14px;
        }
      }
      &__img {

        &--item {
          position: relative; 
          &:before {
          content: '';
          position: absolute;
          background-size: cover;
          background-repeat: no-repeat;
          }
          &.right {
            padding-left: 70px;
            @include max-xl {
              padding-left: 0;
            }
          }
          &.left {
            padding-right: 70px;
            @include max-xl {
              padding-right: 0;
            }
          }
          
          &.item0 {
            &:before {
              background-image: url('~@assets/images/basicplan/blob-1.svg');
              width: 77%;
              padding-bottom: 72%;
              top: -7%;
              right: -10%;
              
            }
          }
          &.item1 {
            &:before {
              background-image: url('~@assets/images/basicplan/blob-2.svg');
              width: 72%;
              padding-bottom: 64%;
              left: -15%;
              bottom: -30%;
            }
          }
          &.item2 {
            &:before {
              background-image: url('~@assets/images/basicplan/shutterstock_551338465.svg');
              width: 72%;
              padding-bottom: 64%;
              right: -20%;
              top: -34%;
            }
          }
          &.item3 {
            &:before {
              background-image: url('~@assets/images/basicplan/blob-3.svg');
              width: 45%;
              padding-bottom: 46%;
              left: -16%;
              top: -17%;
            }
          }
           &.item4 {
            &:before {
              background-image: url('~@assets/images/basicplan/blob-5.svg');
              width: 60%;
              padding-bottom: 65%;
              right: -16%;
              top: -30%;
            }
          }
        }
        
        .img {
          position: relative;
          z-index: 3;
          box-shadow: 0px 5px 20px rgba(40, 45, 78, 0.2);
          border-radius: 10px;
        }
      }
      &__list {
        &:not(:first-child) {
          margin-top: 230px;
          @include max-xl {
            margin-top: 116px;
          }
        }
        
      }
    }
    
  }
}
</style>